import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import AdminUserForm from "./AdminUserForm";
import { toast } from 'react-toastify';

const AdminAddUser = ({ event, children, onChange, ...rest }) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const [form, setForm] = useState({});

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        toast.promise(
            adminHttp.post('/users', form),
            {
                pending: 'Creating user...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        setForm({});
                        onChange();
                        return 'New user created'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    return (
        <>
            <button {...rest} onClick={handleShow}>{children}</button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving user!"}
                        </div>
                    )}

                    <AdminUserForm values={form} errors={error?.errors} onChange={f => setForm(f)} />

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Submit
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default AdminAddUser;
